import { Button, Center, Stack, Text, Title } from '@mantine/core'
import { IconAlertTriangle } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'

import { EmmaPath } from '../router/paths'

export const Debug = () => {
  const navigate = useNavigate()

  return (
    <Center h="100vh">
      <Stack align="center" gap="md">
        <IconAlertTriangle size={48} color="var(--mantine-color-orange-6)" />
        <Title order={3}>Page Not Found</Title>
        <Text c="dimmed" size="sm" maw={400} ta="center">
          The page you are looking for does not exist or has been moved. Please check the URL or return to the
          dashboard.
        </Text>
        <Button variant="filled" color="orange" onClick={() => navigate(EmmaPath.EMMA)}>
          Go to Dashboard
        </Button>
      </Stack>
    </Center>
  )
}
